import React from "react";

export default function StoryBanner() {
  return (
    <section className="storyband" data-testid="story-banner">
      <div className="wrap">
        <div className="story-panel">
          <div className="story-logo"><img src="/brand/logo.png" alt="Energy Vault Group" /></div>
          <h2 className="story-h">We Don&rsquo;t Just Read the Bill.<br /><span className="g">We Reveal the Story Behind It.</span></h2>
          <p className="story-ctx">
            We uncover exactly <b>where, when and why</b> your energy is being wasted — down to the individual asset,
            minute by minute. Most businesses never see it. We make the invisible impossible to miss.
          </p>
          <div className="story-tags">
            <span>Knowledge Before Investment</span>
            <span className="story-dot">·</span>
            <span>Making the Invisible Visible</span>
          </div>
          <a href="/gap-analysis" className="btn story-cta" data-testid="story-cta">Book Your Free Gap Analysis</a>
        </div>
      </div>
    </section>
  );
}
